// Account roles as the super admin's user pages show them. uType codes come
// from Backend/config/userType.js. Each role has its own page under
// Users & Access › Users List; the sidebar and router.js are built from
// USER_PAGES.

export const ROLE_OPTIONS = [
  { value: 772, text: "Public Applicant" },
  { value: 773, text: "Range Forest Officer (RO)" },
  { value: 7741, text: "Section Clerk (DFO Office)" },
  { value: 7742, text: "Superintendent (DFO Office)" },
  { value: 774, text: "Divisional Forest Officer (DFO)" },
  { value: 775, text: "Circle Officer / CCF" },
  { value: 777, text: "HQ Administrator" },
  { value: 778, text: "Government Monitoring (Gov)" },
  { value: 780, text: "Super Administrator" },
];

// The Super Administrator role cannot be given from the UI.
export const CREATABLE_ROLE_OPTIONS = ROLE_OPTIONS.filter((r) => r.value !== 780);

// Officials that sit under a circle / division path.
export const OFFICIAL_TYPES = [774, 773, 7741, 7742];

// Officials that also belong to a division (a DFO is the division itself).
export const DIVISION_STAFF_TYPES = [773, 7741, 7742];

const ROLE_STYLE = {
  780: { icon: "mdi-shield-crown", color: "#7c3aed", soft: "#f5f3ff", badge: "badge-superadmin" },
  778: { icon: "mdi-bank", color: "#c2410c", soft: "#fff7ed", badge: "badge-gov" },
  777: { icon: "mdi-shield-account", color: "#1e40af", soft: "#eff6ff", badge: "badge-admin" },
  775: { icon: "mdi-compass-outline", color: "#0e7490", soft: "#ecfeff", badge: "badge-circle" },
  774: { icon: "mdi-office-building", color: "#15803d", soft: "#f0fdf4", badge: "badge-dfo" },
  7742: { icon: "mdi-clipboard-check", color: "#b45309", soft: "#fffbeb", badge: "badge-superintendent" },
  7741: { icon: "mdi-file-document-edit-outline", color: "#a16207", soft: "#fefce8", badge: "badge-clerk" },
  773: { icon: "mdi-pine-tree", color: "#047857", soft: "#ecfdf5", badge: "badge-range" },
  772: { icon: "mdi-account", color: "#475569", soft: "#f1f5f9", badge: "badge-applicant" },
};

const DEFAULT_STYLE = { icon: "mdi-account", color: "#475569", soft: "#f1f5f9", badge: "badge-default" };

function styleOf(uType) {
  return ROLE_STYLE[Number(uType)] || DEFAULT_STYLE;
}

export function roleName(uType) {
  const match = ROLE_OPTIONS.find((r) => r.value === Number(uType));
  return match ? match.text : `Role (${uType})`;
}

export function roleIcon(uType) {
  return styleOf(uType).icon;
}

export function roleColor(uType) {
  return styleOf(uType).color;
}

export function roleBadgeClass(uType) {
  return styleOf(uType).badge;
}

function rolePage(key, route, name, title, stat, description) {
  const style = key === "all" ? { icon: "mdi-account-group-outline", color: "#15803d", soft: "#e8f4ec" } : styleOf(key);
  return { key, route, name, title, stat, description, icon: style.icon, color: style.color, soft: style.soft };
}

// `stat` is the matching field of GET /superadmin/stats/users.
export const USER_PAGES = [
  rolePage("all", "/superadmin/users", "All Users", "All Users", "total", "Every account across all tiers: credentials, designations and access."),
  rolePage("777", "/superadmin/users/hq-admins", "HQ Admins", "HQ Administrators", "admins", "Headquarters administrator accounts."),
  rolePage("775", "/superadmin/users/circle-officers", "Circle Officers", "Circle Officers / CCF", "circle", "Chief Conservator accounts, one for each circle."),
  rolePage("774", "/superadmin/users/dfos", "DFOs", "Divisional Forest Officers", "dfo", "DFO accounts, one for each division, linked to their circle."),
  rolePage("7742", "/superadmin/users/superintendents", "Superintendents", "Superintendents", "superintendents", "Superintendent accounts in the DFO offices."),
  rolePage("7741", "/superadmin/users/section-clerks", "Section Clerks", "Section Clerks", "clerks", "Section clerk accounts in the DFO offices."),
  rolePage("773", "/superadmin/users/range-officers", "Range Officers", "Range Forest Officers", "range", "Range office accounts, linked to their circle and division."),
  rolePage("772", "/superadmin/users/applicants", "Applicants", "Applicants", "applicants", "Public accounts that apply for film shooting permits."),
  rolePage("778", "/superadmin/users/government", "Government", "Government Monitoring", "gov", "Read-only government monitoring accounts."),
];

export const DUPLICATES_ROUTE = "/superadmin/duplicate-accounts";

export function userPage(key) {
  return USER_PAGES.find((p) => p.key === String(key)) || USER_PAGES[0];
}
